<section class="section" *ngIf="sections1">
    <h2 class="title">{{ sections1.title }}</h2>
    <p class="subtitle">{{ sections1.description }}</p>
</section>


<!-- <section class="section" *ngIf="sections1">
        <h2>{{ sections1.title }} <a  class="take-tour"[href]="sections1.link.url"  *ngIf="showTourLink"><i class="fa-regular fa-wand-sparkles"></i>&nbsp;{{ sections1.link.text }}</a></h2>
        <p>{{ sections1.description }}</p>
    </section> -->